export const getApiAuthHeaders = (options?: { contentType?: boolean }): Record<string, string> => {
  const headers: Record<string, string> = {}
  if (options?.contentType !== false) {
    headers['Content-Type'] = 'application/json'
  }
  const apiKey = process.env.REACT_APP_API_AUTHORIZATION_HEADER_APIKEY
  if (apiKey) {
    const apiKeyValue = process.env.REACT_APP_API_AUTHORIZATION_HEADER_APIKEY_VALUE
    if (apiKeyValue) {
      headers[apiKey] = apiKeyValue
    }
  }
  const token = localStorage.getItem('id_token')
  if (token) {
    headers['wizr-auth'] = token
  }
  return headers
}

export const getApiAuthHeadersAsync = async (options?: { contentType?: boolean }): Promise<Record<string, string>> => {
  const { getValidToken } = await import('./tokenRefresh')
  const headers: Record<string, string> = {}
  if (options?.contentType !== false) {
    headers['Content-Type'] = 'application/json'
  }
  const apiKey = process.env.REACT_APP_API_AUTHORIZATION_HEADER_APIKEY
  if (apiKey) {
    const apiKeyValue = process.env.REACT_APP_API_AUTHORIZATION_HEADER_APIKEY_VALUE
    if (apiKeyValue) {
      headers[apiKey] = apiKeyValue
    }
  }
  const token = await getValidToken()
  if (token) {
    headers['wizr-auth'] = token
  }
  return headers
}

export const fetchAuthenticatedImageUrl = async (url: string): Promise<string | null> => {
  if (!url) return null

  try {
    const response = await fetch(url, { headers: await getApiAuthHeadersAsync({ contentType: false }) })
    if (!response.ok) return null

    const blob = await response.blob()
    return URL.createObjectURL(blob)
  } catch {
    return null
  }
}

export const revokeAuthenticatedImageUrl = (blobUrl: string) => {
  if (blobUrl?.startsWith('blob:')) {
    URL.revokeObjectURL(blobUrl)
  }
}
